import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'getAssignedEmployees'

export default (alternativeCampaignName) => (asyncAction(
  name,
  EmployeesService.getAssignedEmployees,
  { alternativeCampaignName }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/getAssignedEmployees.js